import { useMsg } from '~/common/localizationUtils'
import { getStatusBadgeTokenID, useJobStatusBadgeState } from '~/job/common/utils'
import { JobStatusDisplay } from '~/api/jobs'
import { RoleStatus } from '~/sow/details/time_and_materials/v2/Roles/interfaces'

export function useJobStatusBadgeProps(jobStatus: JobStatusDisplay | RoleStatus) {
  const msg = useMsg()
  const statusBadgeState = useJobStatusBadgeState()
  return {
    variant: statusBadgeState[jobStatus],
    children: msg(getStatusBadgeTokenID.get(jobStatus), { count: 1 })
  }
}
